"use strict";
var lcs_1 = require("./lcs");
function diff(a, b, compareFunc) {
    if (compareFunc === void 0) { compareFunc = (function (ia, ib) { return ia === ib; }); }
    var ret = {
        removed: [],
        added: [],
    };
    lcs_1.default(a, b, compareFunc, function (type, oldArr, oldStart, oldEnd, newArr, newStart, newEnd) {
        if (type === "add") {
            for (var i = newStart; i < newEnd; ++i) {
                ret.added.push(newArr[i]);
            }
        }
        else if (type === "remove") {
            for (var i = oldStart; i < oldEnd; ++i) {
                ret.removed.push(oldArr[i]);
            }
        }
    });
    return ret;
}
exports.diff = diff;
